/**
 * Demo property used during the product tour.
 *
 * This fake property is seeded into the React Query cache so the
 * existing property detail, ask-question, and submit-offer pages
 * render without making API calls.
 */

import type { PropertyResponse } from '@/features/properties/api/properties'

export const DEMO_PROPERTY_ID = 'tour-demo-property'

export const DEMO_PROPERTY: PropertyResponse = {
  id: DEMO_PROPERTY_ID,
  address: {
    street_address: '742 Evergreen Terrace',
    unit_number: null,
    city: 'Austin',
    state: 'TX',
    zipcode: '78701',
  },
  property_type: 'sfh',
  market: 'Austin',
  beds: 4,
  baths: 2,
  sqft: 2248,
  year_built: 2015,
  market_value: 485000,
  status: 'available',
  owner_id: 'demo-agent',
  owner: {
    user_id: 'demo-agent',
    first_name: 'Sarah',
    last_name: 'Johnson',
    public_email: 'sarah.johnson@example.com',
    public_phone: '(512) 555-0142',
  },
  submitted_at: new Date().toISOString(),

  overall_condition: 'good',
  overall_condition_notes: null,
  hvac_install_year: 2023,
  roof_replacement_year: 2015,
  water_heater_install_year: 2019,
  plumbing_condition: 'good',
  plumbing_condition_notes: null,
  electrical_condition: 'excellent',
  electrical_condition_notes: null,
  foundation_condition: 'good',
  foundation_condition_notes: null,
  additional_notes: 'Recently renovated kitchen and bathrooms. New HVAC system installed in 2023.',

  floor_price: null,
  share_market_value: true,
  share_floor_price: false,

  offer_deadline: new Date(Date.now() + 14 * 24 * 60 * 60 * 1000).toISOString().split('T')[0],
  closing_timeline: '30_days',
  open_house_dates: null,

  created_at: new Date().toISOString(),
  updated_at: new Date().toISOString(),

  media: [],
  thumbnail: null,
}
